import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { StyledModal } from './style';

function CreativeMetadataModal({ show, onHide, data }) {
  return (
    <StyledModal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Creative Metadata</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(data).map(key => (
          <div className="data-container">
            <div className="data-key">{key}</div>
            <div className="data-value">{String(data[key])}</div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
}

export default CreativeMetadataModal;
